export const FETCH_COUNTRY_INIT_ACTION = "FETCH_COUNTRY_INIT_ACTION";
export const FETCH_COUNTRY_SUCCESS_ACTION =
  FETCH_COUNTRY_INIT_ACTION + "_SUCCESS";
export const FETCH_COUNTRY_FAIL_ACTION = FETCH_COUNTRY_INIT_ACTION + "_ERROR";

export const FETCH_SUB_COUNTRY_INIT_ACTION = "FETCH_SUB_COUNTRY_INIT_ACTION";
export const FETCH_SUB_COUNTRY_SUCCESS_ACTION =
  FETCH_SUB_COUNTRY_INIT_ACTION + "_SUCCESS";
export const FETCH_SUB_COUNTRY_FAIL_ACTION =
  FETCH_SUB_COUNTRY_INIT_ACTION + "_ERROR";

export const FETCH_CURRENCY_INIT_ACTION = "FETCH_CURRENCY_INIT_ACTION";
export const FETCH_CURRENCY_SUCCESS_ACTION =
  FETCH_CURRENCY_INIT_ACTION + "_SUCCESS";
export const FETCH_CURRENCY_FAIL_ACTION = FETCH_CURRENCY_INIT_ACTION + "_ERROR";

export const FETCH_COUNTRYBYID_INIT_ACTION = "FETCH_COUNTRYBYID_INIT_ACTION";
export const FETCH_COUNTRYBYID_SUCCESS_ACTION =
  FETCH_COUNTRYBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_COUNTRYBYID_FAIL_ACTION =
  FETCH_COUNTRYBYID_INIT_ACTION + "_ERROR";

export const ADD_CNTRY_CRNCY_INIT_ACTION = "ADD_CNTRY_CRNCY_INIT_ACTION";
export const ADD_CNTRY_CRNCY_SUCCESS_ACTION =
  ADD_CNTRY_CRNCY_INIT_ACTION + "_SUCCESS";
export const ADD_CNTRY_CRNCY__FAIL_ACTION =
  ADD_CNTRY_CRNCY_INIT_ACTION + "_ERROR";

export const FETCH_CNTRY_CRNCY_INIT_ACTION = "FETCH_CNTRY_CRNCY_INIT_ACTION";
export const FETCH_CNTRY_CRNCY_SUCCESS_ACTION =
  FETCH_CNTRY_CRNCY_INIT_ACTION + "_SUCCESS";
export const FETCH_CNTRY_CRNCY__FAIL_ACTION =
  FETCH_CNTRY_CRNCY_INIT_ACTION + "_ERROR";

export const DELETE_CNTRY_CRNCY_INIT_ACTION = "DELETE_CNTRY_CRNCY_INIT_ACTION";
export const DELETE_CNTRY_CRNCY_SUCCESS_ACTION =
  DELETE_CNTRY_CRNCY_INIT_ACTION + "_SUCCESS";
export const DELETE_CNTRY_CRNCY_FAIL_CTION =
  DELETE_CNTRY_CRNCY_INIT_ACTION + "_ERROR";

export const EDIT_CNTRY_CRNCY_INIT_ACTION = "EDIT_CNTRY_CRNCY_INIT_ACTION";
export const EDIT_CNTRY_CRNCY_SUCCESS_ACTION =
  EDIT_CNTRY_CRNCY_INIT_ACTION + "_SUCCESS";
export const EDIT_CNTRY_CRNCY_FAIL_ACTION =
  EDIT_CNTRY_CRNCY_INIT_ACTION + "_ERROR";

export function fetchCountryList() {
  return {
    type: FETCH_COUNTRY_INIT_ACTION,
  };
}

export function fetchCurrencyList() {
  return {
    type: FETCH_CURRENCY_INIT_ACTION,
  };
}

export function fetchCountryById(value) {

  return {
    type: FETCH_COUNTRYBYID_INIT_ACTION,
    value: value,
  };
}

export function AddCntryCrncy(value) {
  return {
    type: ADD_CNTRY_CRNCY_INIT_ACTION,
    value: value,
  };
}

export function fetchCntryCrnvy() {
  return {
    type: FETCH_CNTRY_CRNCY_INIT_ACTION,
  };
}

export function DeleteCrntryCrncy(value) {

  return {
    type: DELETE_CNTRY_CRNCY_INIT_ACTION,
    value:value
  };
}

export function cntryCrncySelectedPage(value) {
  return {
    type: FETCH_CNTRY_CRNCY_INIT_ACTION,
    value: value,
  };
}

export function EditCntryCurency(value) {

  return {
    type: EDIT_CNTRY_CRNCY_INIT_ACTION,
    value: value,
  };
}
